/**
 * @deprecated Do not use legacy components anymore.
 */
export var BackgroundStatusCategories;
(function (BackgroundStatusCategories) {
    BackgroundStatusCategories["Active"] = "active_";
    BackgroundStatusCategories["Disabled"] = "disabled_";
    BackgroundStatusCategories["Error"] = "error";
})(BackgroundStatusCategories || (BackgroundStatusCategories = {}));
//# sourceMappingURL=BackgroundStatusCategories.js.map